export default __webpack_public_path__ + "img/b906fcb5aa94c07c57508e5314c7ec30.svg";